import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as Styled from './OrderCancelModal.styles';
import ModalWindow from '../ModalWindow';
import { OrderTableData } from '../../containers/OrdersPage/types';
import * as ordersActions from '../../containers/OrdersPage/actions';
import { selectors as ordersSelectors } from '../../containers/OrdersPage/reducer';
import CustomTextarea from '../CustomTextarea';
import Button from '../Button';

interface OrderCancelModalProps {
  onDecline: (data: OrderTableData) => void;
  onSubmit: (msg: string, id: string, innerMessage: string) => void;
  data: any;
}

const OrderCancelModal = ({
  onDecline,
  onSubmit,
  data,
}: OrderCancelModalProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [message, setMessage] = useState<string>('');
  const [innerMessage, setInnerMessage] = useState<string>('');
  const [errorTooltip, setErrorTooltip] = useState<boolean>(false);
  const cancelReasonsData = useSelector(ordersSelectors.cancelReasonsData);

  const handleMessageChange = (value: string) => {
    setMessage(value);
    setErrorTooltip(false);
  };

  const handleInnerMessageChange = (value: string) => {
    setInnerMessage(value);
    setErrorTooltip(false);
  };

  const handleDecline = () => {
    onDecline(data);
  };

  const handleSubmit = () => {
    if (message !== '' && innerMessage !== '') {
      onSubmit(message, data.id, innerMessage);
    } else setErrorTooltip(true);
  };

  useEffect(() => {
    dispatch(
      ordersActions.getCancelReasons.request({
        key: process.env.REACT_APP_INTEGRATION_NETWORK
          ? 'cancel_reason-ik'
          : 'cancel_reason',
      })
    );
  }, []);

  return (
    <ModalWindow onClose={handleDecline}>
      <Styled.OrderCancelModalContent>
        <div className="modal-title">{t('OrderCancelModal.MODAL_TITLE')}</div>
        <div className="modal-subtitle">
          {t('OrderCancelModal.MODAL_SUBTITLE')}
        </div>
        <div className="cancel-reason__title">
          {t('OrderCancelModal.CANCEL_REASON_TITLE')}
        </div>
        <CustomTextarea
          isResizable
          value={message}
          onChange={handleMessageChange}
          placeholder={t('OrderCancelModal.TEXT_AREA_PLACEHOLDER')}
        />
        <div className="cancel-reason__title" style={{ marginTop: 20 }}>
          {t('OrderCancelModal.INNER_REASON_TITLE')}
        </div>
        <div className="wrapper">
          <div className="container-textarea">
            <CustomTextarea
              onChange={(e) => console.log(e)}
              value={innerMessage}
              placeholder={t('OrderPage.TimerOperator.COMMENT_PLACEHOLDER')}
            />
          </div>
          <select
            onChange={(e) => handleInnerMessageChange(e.target.value)}
            value={innerMessage}
            className="select-group"
          >
            {cancelReasonsData &&
              cancelReasonsData.map((text) => (
                <option value={text} key={text}>
                  {text}
                </option>
              ))}
          </select>
        </div>
        <div className="controls-block">
          <div className="decline-btn__container">
            <Button
              onClick={handleDecline}
              text={t('OrderCancelModal.DECLINE_BTN')}
              variant="outlined"
            />
          </div>
          <div className="submit-btn__container">
            {errorTooltip && (
              <div className="error-tooltip">
                {t('OrderCancelModal.ERROR_TOOLTIP')}
              </div>
            )}
            <Button
              onClick={handleSubmit}
              text={t('OrderCancelModal.SUBMIT_BTN')}
            />
          </div>
        </div>
      </Styled.OrderCancelModalContent>
    </ModalWindow>
  );
};

export default OrderCancelModal;
